import { Component, OnInit } from '@angular/core';
import { AppInfoService } from 'src/app/shared/services/app-info.service';
import { Auth0Service } from 'src/app/auth/auth0.service';
import { Landing } from 'src/app/shared/models/landing';
import { MedigiComponentCopyService } from '../medigi-component-copy.service';
import * as Aos from 'aos';
import { ScreenService } from 'src/app/shared/services/screen.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
  selector: 'app-medigi-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class MedigiHomeComponent implements OnInit {
  cardInfo: any;
  fifthContainerVisable = false;
  mobileUser = false;

  constructor(
    public appService: AppInfoService,
    private auth0: Auth0Service,
    private medigiCopy: MedigiComponentCopyService,
    public screenService: ScreenService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  ngOnInit() {
    Aos.init();
    this.getUserScreenSize();
    this.cardInfo = this.medigiCopy.cards.largeCard.homepage;
  }

  ngOnChanges() {
    this.getUserScreenSize();
  }

  signIn() {
    this.auth0.login();
  }

  getUserScreenSize() {
    if (
      this.screenService.sizes['screen-small'] === true ||
      this.screenService.sizes['screen-x-small'] === true
    ) {
      this.mobileUser = true;
    }
  }

  sendToGa(eventName, eventCategory) {
    this.googleAnalyticsService.eventEmitter(eventCategory, eventName);
  }
}
